import React, { useEffect, useState ,useContext} from 'react'
import DocumentTitle from '../../../../components/DocumentTitle/DocumentTitle'
import Erreurs from '../../../../components/Erreurs/Erreurs'
import { Box } from '@mui/material'
import { DataGridPremium, GridToolbar,frFR,useGridApiRef } from "@mui/x-data-grid-premium";
import { useRecoilState } from 'recoil';
import { loadingState } from '../../../../recoil/atoms/loadingAtom';
import Api from '../../../../services/Api';
import moment from 'moment';
import CustomToolbar from '../../../../components/APC/CustomToolBar/CustomToolbar';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../../../../services/Context/Context';

const ListeAutorisationPaiement = () => {
  const [ erreurs,setErreurs ] = useState([]);
  const [ isLoading,setIsLoading ] = useRecoilState(loadingState);
  const { privileges } = useContext(UserContext);

  const [filterModel, setFilterModel] = useState({
    items: []
  });
  const[ pageState,setPageState ] = useState({
    data:[],
    total: 0,
    page: 0,
    pageSize: 10 
  });
  const [formFilters, setFormFilters] = useState({
    reference: '',
    startDate: '',
    endDate: ''
  });
  const api = new Api();
  const apiRef = useGridApiRef();
  const navigate  = useNavigate();
  let { state } = useLocation();
  //console.log(state);
  const columns = [
    {
      field: "ordre",
      headerName: "N°",
      minWidth: 80,
    },
    {
      field: "fullName",
      headerName: "Prénom et Nom",
      minWidth: 110,
    },
    {
      field: "telephone",
      headerName: "Téléphone",
      minWidth: 140
    },
    {
      field: "groupID",
      headerName: "Réference",
      minWidth: 110
    },
    {
      field: "typeDemandeur",
      headerName: "Demandeur",
      minWidth: 120
    },
    {
      field: "typeAutorisation",
      headerName: "Autorisation",
      minWidth: 120
    },
    {
      field: "marque",
      headerName: "Marque",
      minWidth: 110
    },
    {
      field: "modele",
      headerName: "Modèle",
      minWidth: 110
    },
    {
      field: "categorie",
      headerName: "Categorie",
      minWidth: 120
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 95
    },
    {
      field: "paysProvenance",
      headerName: "Provenance",
      minWidth: 90
    },
    {
      field: "paysDestination",
      headerName: "Destination",
      minWidth: 90
    },
    {
      field: "dateExpiration",
      headerName: "Date Expiration",
      minWidth: 110
    },
    {
      field: "created_at",
      headerName: "Date Création",
      minWidth: 110
    },
    {
      field: "options",
      headerName: "Options",
      sortable: false,
      flex: 1,
      hide:false,
      filterable: false ,
      sortable:false,
      minWidth: 210,
     
      renderCell: (params) => {
        const id = params.row.groupID;
      //  console.log(params.row);
        return (
          <div className="options">
            <button onClick={() => navigate(`/apc/invoice/${id}`)}>Détails</button>
            { privileges.some(p => p.privilege === "Edition AEP") && <button className={`edit ${params.row.status === 'En attente' ?'': 'disabled'}` }  onClick={() => navigate(`/apc/edition`,{state:{id:id}})} >Editer</button>}
          </div>    
        )}
    }
  ];
  const getPaiements = async () => {
    try{
        setIsLoading(true);
         const page =  pageState.page + 1; 
         let params = {
          pageSize: pageState.pageSize,
          currentPage: page,
          ...formFilters // Include form filters
         }
          if (filterModel.items.length > 0) {
            filterModel.items.forEach(filter => {
              if (filter.value && filter.value.toString().trim() !== '') {
                params[`filter[${filter.field}]`] = filter.value;
              }
            });
          }  
          if( typeof state?.title !== 'undefined' ){
             params["filter[status]"] = state.title.toLowerCase();
              // if( state.filter_id === 2 ){
              //   // params["filter[typeAutorisation]"] = "circulation temporaire";
              //    params["filter[status]"] = "en attente"
              // }
              // else if( state.filter_id === 3 ){
              // //  params["filter[typeAutorisation]"] = "transit";
              //   params["filter[status]"] = "valide"
              // }
              // else if( state.filter_id === 4 ){
              //   params["filter[status]"] = "en attente"
              // }
          }
          var url = `/paiement/apc/liste?mode=paiement`;
        
          const { status,data,errors } = await api.apiData('get',url,{ params });
         // console.log(params);
          let getData = [];
          if( status === 200 ){
             if( data.data.length > 0 ){
              
                getData =  data.data.map((item,index) => {
                 const currentDate = moment();
                 return{
                   id: index + 1,
                   ordre: data.from + index,
                   fullName: item.fullName,
                   telephone: item.telephone,
                   reference:item.groupID,
                   typeDemandeur: item.typeDemandeur.charAt(0).toUpperCase() + item.typeDemandeur.slice(1),
                   typeAutorisation: item.typeAutorisation.charAt(0).toUpperCase() +  item.typeAutorisation.slice(1),                  
                   marque: item.marqueName,
                   modele:item.modeleName,
                   categorie:item.categorie,
                   paysProvenance:item.paysProvenance,
                   paysDestination:item.paysDestination,  
                   dateExpiration: moment(item.dateExpiration).format("DD/MM/YYYY"),
                   status: currentDate.isAfter(item.dateExpiration) ?  "Expiré" : parseInt(item.printeCount) > 0 ? "Imprimé" : item.status?.charAt(0).toUpperCase() + item.status?.slice(1),
                   created_at: moment(item.created_at).format("DD/MM/YYYY"),
                   groupID: item.groupID               
                 }
               });

             }
          }
          setPageState((prev) => ({...prev,data: getData,total:data?.total}));
    }
    catch(e){
      console.log(e);
      setErreurs([{ message: "Failed to load data" }]);

    }
    finally{
      setIsLoading(false)
    }
  }
  const handlePaginationModelChange = (newPaginationModel) => {
    setPageState(prev => ({
      ...prev,
      page: newPaginationModel.page,
      pageSize: newPaginationModel.pageSize
    }));
  };
  // Handle form filter changes
  const handleFormFilterChange = (e) => {
  const { name, value } = e.target;
  setFormFilters(prev => ({
    ...prev,
    [name]: value?.toUpperCase()
  }));
  
  // Initialiser la pagination quand on commence à filtrer
  setPageState(prev => ({ ...prev, page: 0 }));
 }; 
 const handleFilterModelChange = (newModel) => {
     setFilterModel(newModel);
    // Initialiser la pagination quand les filtres changent
    state = undefined;
    setPageState(prev => ({ ...prev, page: 0 }));
 };
  useEffect(() => {
      getPaiements()
  },[pageState.page,pageState.pageSize,filterModel]);
 const handleFormSubmit = (e) => {
    e.preventDefault();
    // Initialiser la pagination quand on soumet le formulaire de filtre
    state = undefined;
    setPageState(prev => ({ ...prev, page: 0 }));
    // Trigger data fetch
    getPaiements();
 };
 
  return (
    <div className='payment-list page'>
      <DocumentTitle title="Liste des autorisations provisoire de circulation" />
      <div className='header'>
         <h3>Liste de paiements des Attestations d'Enregistrement Primaire</h3>
      </div>
      <div className="filters">
          <form onSubmit={handleFormSubmit}>
            <h4>Filtres</h4>
            <div className="input-group">
              <label>
                Numero de chassis
                <input type="text"
                     name="numeroChassis" id="chassisRef" 
                     placeholder="Numéro de chassis"
                     value={formFilters.numeroChassis}
                     onChange={handleFormFilterChange}
                    />
              </label>
            
              <label>
                Date début
                <input type="date" name="startDate" 
                  id="startDate" 
                  placeholder="Date de début"
                  value={formFilters.startDate}
                  onChange={handleFormFilterChange}    
                  />
              </label>
              <label>
                Date fin
                <input type="date" name="endDate"
                  id="endDate" 
                  placeholder="Date de fin"
                  value={formFilters.endDate}
                  onChange={handleFormFilterChange}
                  />
              </label>
            </div>
            <Erreurs validation = {erreurs} />
            <button type="submit">Rechercher</button>
          </form>
       </div>
       <div className="array">
        <Box sx={{ height:"57vh",width: "100%" }}>
           <DataGridPremium
              sx={{ borderRadius: 0 }}
              density="compact"
              columns={columns}
              autoPageSize
              pagination
              disableSelectionOnClick={false}
              localeText={ frFR.components.MuiDataGrid.defaultProps.localeText }
              rows={pageState.data || []}
              rowCount={pageState.total || 0}
              page={pageState.page - 1 }
             
              onPaginationModelChange={handlePaginationModelChange}
              onFilterModelChange={handleFilterModelChange}
              paginationMode="server"
              onPageSizeChange={(newpageSize, details ) => {
                // Maybe save into state
                setPageState((prev) => ({...prev,pageSize:newpageSize}))
              }}
              onPageChange={(newPage) => {
                setPageState(prev => ({ ...prev, page: newPage + 1 }))
              }}
              apiRef={apiRef}
              filterMode="server"
              slots={{
                toolbar: () => <CustomToolbar 
                                  apiRef={apiRef} 
                                  formFilters={formFilters}  
                                  filterModel={filterModel}
                                  setIsLoading={setIsLoading} 
                                  isLoading={isLoading}
                                  />,
              }}
             
            />  
         </Box>
       </div>     
    </div>
  )
}

export default ListeAutorisationPaiement;
